import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { PopupType } from '../components/popup-dialog/popup-dialog.component';

/**
 * Service de gestion des erreurs de l'application.
 */
@Injectable({
  providedIn: 'root',
})
export class PopupService {
  isTriggered$ = new Subject<boolean>();
  choice$ = new Subject<boolean>();
  message: string;
  type: PopupType;
  actions: any[];

  /**
   * Creates an instance of {@link PopupService}.
   * @constructor
   *
   * @memberof PopupService
   */
  constructor() {
    this.isTriggered$.next(false);
  }

  /**
   * Suppression de l'erreur.
   *
   * @memberof PopupService
   */
  clear(): void {
    this.type = undefined;
    this.message = undefined;
    this.isTriggered$.next(false);
  }

  /**
   * Emet le choix de la popup
   *
   * @memberof PopupService
   */
  setChoice(choice): void {
    this.choice$.next(choice);
  }

  /**
   * Crée une nouvelle erreur.
   *
   * @param code Code de l'erreur
   * @param message Message de l'erreur
   * @memberof PopupService
   */
  trigger(type, message, actions): Observable<boolean> {
    this.type = type;
    this.message = message;
    this.actions = actions;
    this.isTriggered$.next(true);
    return this.subscribeChoice();
  }

  /**
   * Retourne un observable de choice
   *
   * @return {*}  {Observable<boolean>}
   * @memberof PopupService
   */
  subscribeChoice(): Observable<boolean> {
    return this.choice$.asObservable();
  }

  /**
   * Retourne un observable de inError
   *
   * @return {*}  {Observable<boolean>}
   * @memberof PopupService
   */
  subscribeTrigger(): Observable<boolean> {
    return this.isTriggered$.asObservable();
  }

  /**
   * Retourne si il y a une erreur ou pas
   *
   * @return {*}  {boolean}
   * @memberof PopupService
   */
  isTriggered(): boolean {
    return this.type && this.message ? true : false;
  }

  /**
   * Retourne le message de l'erreur.
   *
   * @return {*}  {string}
   * @memberof PopupService
   */
  getMessage(): string {
    return this.message;
  }

  /**
   * Retourne le coed de l'erreur.
   *
   * @return {*}  {number}
   * @memberof PopupService
   */
  getType(): PopupType {
    return this.type;
  }

  /**
   * Retourne le tableau d'actions
   *
   * @return {*}  {any[]}
   * @memberof PopupService
   */
  getActions(): any[] {
    return this.actions;
  }
}
